import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aa0c758a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]


import { Show } from '@/models/models';


export default /*#__PURE__*/_defineComponent({
  props: {
    show: null
  },
  setup(__props: any) {

const props = __props as {
  show: Show
}




return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: `/show/${props?.show?.id}`
  }, {
    default: _withCtx(() => [
      _createElementVNode("img", {
        src: props?.show?.image?.medium,
        alt: "Not found"
      }, null, 8, _hoisted_1),
      _createElementVNode("p", null, _toDisplayString(__props.show.name), 1)
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})